var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (state, translate, view) {
buf.push("<form class=\"modal-body coppa-deny\"><div class=\"modal-body-content\"><div class=\"parent-email-input-group form-group\">");
if ( !view.state.get('parentEmailSent'))
{
buf.push("<label for=\"parent-email-input\" class=\"control-label text-h4\"><span data-i18n=\"signup.enter_parent_email\"></span></label><input id=\"parent-email-input\" type=\"email\" name=\"parentEmail\"" + (jade.attr("value", state.get('parentEmail'), true, true)) + ">");
if ( state.get('error'))
{
buf.push("<p class=\"small error\"><span data-i18n=\"signup.parent_email_error\"></span></p>");
}
buf.push("<p" + (jade.cls(['error',(state.get('dontUseOurEmailSilly') ?  '' : 'hidden')], [null,true])) + "><span data-i18n=\"signup.dont_use_our_email_silly\"></span></p><p class=\"small parent-email-blurb render\"><span>" + (null == (jade_interp = translate('signup.parent_email_blurb').replace('{{email_link}}', '<a href="mailto:team@codecombat.com">team@codecombat.com</a>')) ? "" : jade_interp) + "</span></p>");
}
if ( view.state.get('parentEmailSent'))
{
buf.push("<p class=\"small parent-email-blurb\"><span data-i18n=\"signup.parent_email_sent\"></span></p><a href=\"/play\" data-dismiss=\"modal\" class=\"btn btn-navy btn-lg\">Play without saving</a>");
}
buf.push("</div></div><!-- In reverse order for tabbing purposes--><div class=\"history-nav-buttons\"><button type=\"submit\"" + (jade.attr("disabled", state.get('parentEmailSent') || state.get('parentEmailSending') ||  state.get('dontUseOurEmailSilly'), true, true)) + " class=\"send-parent-email-button btn btn-lg btn-navy\">");
if ( state.get('parentEmailSent'))
{
buf.push("<span data-i18n=\"common.sent\"></span>");
}
else
{
buf.push("<span data-i18n=\"common.send\"></span>");
}
buf.push("</button><button type=\"button\" class=\"back-btn btn btn-lg btn-navy-alt\"><span data-i18n=\"common.back\"></span></button></div></form>");}.call(this,"state" in locals_for_with?locals_for_with.state:typeof state!=="undefined"?state:undefined,"translate" in locals_for_with?locals_for_with.translate:typeof translate!=="undefined"?translate:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/coppa-deny-view.jade
// module id = 822
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91